import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { useTranslation } from 'react-i18next';
import plus from '../../assests/plus.svg';
import edit from '../../assests/edit.svg';
import './serviceCodes.css';

const ServiceCodes = () => {
  const { t, i18n } = useTranslation();
  const [serviceCodes, setServiceCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();
  const location = useLocation();

  useEffect(() => {
    fetchServiceCodes();
  }, [token, i18n.language, location.state?.updated]);

  const fetchServiceCodes = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://naql.nozzm.com/api/service_codes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'lang': i18n.language,
        },
        body: JSON.stringify({}),
      });

      const result = await response.json();
      if (result.status) {
        setServiceCodes(result.data.data || []);
      } else {
        setError(result.message || 'Failed to fetch service codes');
      }
    } catch (error) {
      setError('Error fetching service codes');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (serviceCode) => {
    // Navigate to edit page with service code data
    window.location.href = `/ServiceCodeData?id=${serviceCode.id}`;
  };

  if (loading) {
    return (
      <div className="container tables bg-white mt-5">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container tables bg-white mt-5">
      <div className="tableTitle d-flex justify-content-between">
        <h3>{t('serviceCodes.title')}</h3>
        <Link to="/ServiceCodeData">
          <button className="btn btn-primary">
            <img src={plus} alt="" />
            <span className="pe-3">{t('serviceCodes.addCode')}</span>
          </button>
        </Link>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="table-responsive">
        <table className="table borderless TableDr text-center">
          <thead>
            <tr>
              <th scope="col">{t('serviceCodes.codeNumber')}</th>
              <th scope="col">{t('serviceCodes.codeName')}</th>
              <th scope="col">{t('control')}</th>
            </tr>
          </thead>
          <tbody>
            {serviceCodes.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  لا توجد أكواد خدمات
                </td>
              </tr>
            ) : (
              serviceCodes.map((serviceCode) => (
                <tr key={serviceCode.id}>
                  <td>{serviceCode.code_number}</td>
                  <td>{serviceCode.code_name}</td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => handleEdit(serviceCode)}
                        title={t('edit')}
                      >
                        <img src={edit} alt="Edit" style={{ width: '16px', height: '16px' }} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceCodes;
